import { render, staticRenderFns } from "./FileManagerFile.vue?vue&type=template&id=a05ce2ca&"
import script from "./FileManagerFile.vue?vue&type=script&lang=js&"
export * from "./FileManagerFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports